import React from 'react';

const FloatingBackButton = () => {
  return (
    <a
      href="https://www.primehost.co.za/#/portfolio"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 left-5 z-[9999] bg-purple-600/80 hover:bg-purple-600 text-white px-5 py-3 rounded-full font-poppins font-medium text-sm transition-all duration-300 ease-in-out backdrop-blur-sm border border-white/20 hover:transform hover:-translate-y-1 hover:shadow-lg hover:shadow-purple-600/25"
      style={{ boxShadow: '0 4px 15px rgba(139,92,246,0.2)' }}
    >
      Back to Primehost
    </a>
  );
};

export default FloatingBackButton;